import React, { Dispatch, SetStateAction } from 'react';
import { Dropdown } from 'react-bootstrap';
import { format } from 'date-fns';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { Company } from '../../models/company.model';
import { Deadline } from '../../models/deadline.model';
import { Settings } from '../../models/settings.model';
import { legendInvalid, legendValid } from '../../utils/legend.data.util';
import { modalShow } from '../../utils/modal.util';
import { formatDeadline } from '../../scripts/format.value.script';

import AppLegend from './Legend';
import AppModalSettingsCreateDeadline from '../modal/ModalSettingsCreateDeadline';

export interface AppInputDatePaymentProps {
  companyForUser: Company,
  settingsForCompany: Settings,
  validUntil: {value: string, valid: boolean},
  deadline: {value: string, valid: boolean, object: any},
  setValidUntil: Dispatch<SetStateAction<{value: string, valid: boolean}>>,
  setDeadline: Dispatch<SetStateAction<{value: string, valid: boolean, object: any}>>,
  loadSettingsForCompany: Function
};

const AppInputDatePayment: React.FunctionComponent<AppInputDatePaymentProps> = ({companyForUser, settingsForCompany, validUntil, deadline, setValidUntil, setDeadline, loadSettingsForCompany}) => {
  const {lang} = StateLanguage()

  const handleChangeValidUntil = (event: React.ChangeEvent <HTMLFormElement | HTMLInputElement>) => {
    setDeadline({value: '', valid: false, object: null})

    if (event.target.value.length > 0) {
      setValidUntil({value: event.target.value, valid: true})
      legendValid('legend-valid-until-required')
    } else {
      setValidUntil({value: event.target.value, valid: false})
      legendInvalid('legend-valid-until-required')
    }
  }

  const handleChangeDeadline = (item: Deadline) => {
    let currentDate: Date = new Date()

    switch (item.type) {
      case 'day':
        currentDate.setDate(currentDate.getDate() + item.quantity)
        break;
      case 'week':
        currentDate.setDate(currentDate.getDate() + item.quantity * 7)
        break;
      case 'month':
        currentDate.setMonth(currentDate.getMonth() + item.quantity)
        break;  
      case 'year':
        currentDate.setFullYear(currentDate.getFullYear() + item.quantity)
        break;
    }

    setValidUntil({value: format(currentDate, 'yyyy-MM-dd'), valid: true})
    setDeadline({value: item.id, valid: true, object: item})
    legendValid('legend-valid-until-required')
  }

  const executeShowModalSettingsCreatePaymentDeadline = () => {
    modalShow('modal-settings-create-payment-deadline')
  }

  function currentDate(): string {
    return format((new Date()), 'yyyy-MM-dd')
  }

  return (
    <>
      <div className="d-flex align-self-center">
        <div className="flex-equal">
          <input className="form-control" type="date" name="valid-until" autoComplete="off" min={currentDate()} value={validUntil.value.substring(0, 10)} onChange={handleChangeValidUntil} />
        </div>
        <div className="form-text text-center align-middle text-uppercase m-0 py-3 px-2">{lang.labels.or}</div>
        <div className="flex-equal">
          <Dropdown>
            <Dropdown.Toggle variant="select2 select2-container select2-container--bootstrap5 select2-container--below select2-container--focus select2-container--open w-100 p-0">
              <span className="selection">
                <span className="select2-selection select2-selection--single form-select">
                  <span className="select2-selection__rendered" role="textbox">
                    {deadline.valid ? formatDeadline(lang, deadline.object) : lang.labels.selectOption}
                  </span>
                </span>
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu variant="select2-container select2-container--bootstrap5 select2-container--open w-100">
              <span className="select2-dropdown select2-dropdown--below">
                <span className="select2-results">
                  <ul className="select2-results__options" role="listbox">
                    <li className="select2-results__option select2-results__option--selectable">
                      <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => executeShowModalSettingsCreatePaymentDeadline()}>
                        <div className="d-flex align-items-center">
                          <span className="svg-icon svg-icon-3 me-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="black" />
                              <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="black" />
                              <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="black" />
                            </svg>
                          </span>
                          {lang.labels.addDeadline}
                        </div>
                      </Dropdown.Item>
                    </li>
                    <li className={`select2-results__option select2-results__option--selectable ${settingsForCompany.payment_deadlines.length > 0 && "d-none"}`}>
                      <Dropdown.Item bsPrefix="select2-results__option__text">{lang.labels.selectOption}</Dropdown.Item>
                    </li>
                    { settingsForCompany.payment_deadlines.map (( (item, index) => { return (
                      <li key={index} className={`select2-results__option select2-results__option--selectable ${item.id === deadline.value && "select2-results__option--selected"}`} role="option" aria-selected={item.id === deadline.value}>
                        <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => handleChangeDeadline(item)}>{formatDeadline(lang, item)}</Dropdown.Item>
                      </li>
                    )}))}
                  </ul>
                </span>
              </span>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <AppLegend attribute={{check: validUntil.valid, name: "valid-until", index: null, sub_index: null}} container={{valid: false, required: true, identical: false, exists: false}}></AppLegend>
      <AppModalSettingsCreateDeadline companyForUser={companyForUser} setValidUntil={setValidUntil} setPaymentDeadline={setDeadline} loadSettingsForCompany={loadSettingsForCompany}></AppModalSettingsCreateDeadline>
    </>
  )
}

export default AppInputDatePayment;
